<template>
  <Recursion :data="newData" :vocabulary="vocabulary" :level="0" :isRenderEmpty="isRenderEmpty" :specialClasses="specialClasses" />
</template>
<script>
import Recursion from "./components/Recursion.vue";
export default {
  components: { Recursion },
  props: {
    data: {
      type: Object,
      required: true,
    },
    // key value map for translating keys. By default, if translation is not found, key is used.
    vocabulary: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    // if true, empty fields/arrays/objects will be rendered
    isRenderEmpty: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Array of strings (keys). If provided, keys will be rendered in the order they are provided.
    orderFirst: {
      type: Array,
      required: false,
      default: () => [],
    },
    // Object with classes that will be added to the rendered elements. Key is the field name, value is the class name.
    specialClasses: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    // For printing purposes
    imLoaded: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      newData: structuredClone(this.data),
    };
  },
  mounted() {
    this.tryReorder();
    this.tryPrint();
  },
  methods: {
    tryReorder() {
      if (!Array.isArray(this.orderFirst) || this.orderFirst.length === 0) {
        return;
      }
      const data = structuredClone(this.data);
      const keys = Object.keys(data);
      const orderedKeys = this.orderFirst.filter((key) => keys.includes(key));
      const unorderedKeys = keys.filter((key) => !this.orderFirst.includes(key));
      const orderedData = orderedKeys.reduce((acc, key) => {
        acc[key] = data[key];
        return acc;
      }, {});
      const unorderedData = unorderedKeys.reduce((acc, key) => {
        acc[key] = data[key];
        return acc;
      }, {});
      this.newData = { ...orderedData, ...unorderedData };
    },
    tryPrint() {
      if (this.imLoaded) {
        this.$nextTick(() => {
          this.imLoaded();
        });
      }
    },
  },
};
</script>
<style scoped>
/* PT Sans supports cyrillic characters and PT Sans is used in pdf generations. */
* {
  font-family: "PT Sans" !important;
  font-weight: normal;
}
</style>